module.exports = __webpack_public_path__ + "static/media/jw_gold.d1ab0e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/General/jw_gold.jpg
// module id = 717
// module chunks = 0